import clsx from 'clsx';
import { forwardRef } from 'react';

import Loader from '../Loader/Loader';

type Props = {
  children: React.ReactNode;
  type?: 'primary' | 'secondary' | 'cancel' | 'outline' | 'input' | 'text' | 'remove';
  size?: 'normal' | 'small' | 'full';
  disabled?: boolean;
  loading?: boolean;
  style?: any;
  onClick?: () => void;
  className?: string;
};

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      children,
      type = 'primary',
      size = 'normal',
      disabled = false,
      onClick,
      loading = false,
      className,
      style,
      ...rest
    }: Props,
    ref
  ) => {
    const click = (e: React.MouseEvent) => {
      e.preventDefault();
      if (onClick) {
        onClick();
      }
    };

    return (
      <button
        type="button"
        disabled={disabled || loading}
        onClick={click}
        style={style}
        className={clsx(
          'rounded-md hover:shadow-md',
          size === 'full' && 'w-full h-[52px]',
          size === 'normal' && 'w-[200px] h-[52px]',
          size === 'small' && 'w-[90px] h-[40px]',
          type === 'primary' && 'bg-primary text-white hover:brightness-[95%]',
          type === 'secondary' &&
          'bg-secondary text-white hover:brightness-[95%] font-semibold',
          type === 'cancel' &&
          'bg-white text-errorText border-errorText border-2 hover:brightness-[95%]',
          type === 'outline' &&
          'bg-white text-primary border-primary border-2 font-semibold',
          type === 'text' &&
          'bg-transparent text-primary font-semibold hover:!brightness-100 hover:!shadow-none',
          type === 'input' &&
          'bg-lightGrey text-textSecondary hover:brightness-95 hover:!shadow-none',
          type === 'remove' && 'text-primary font-semibold hover:!shadow-none',
          (disabled || loading) && 'opacity-25 hover:!brightness-100 hover:!shadow-none',
          className
        )}
        data-testid="button"
        ref={ref}
        {...rest}
      >
        {loading ? <Loader /> : children}
      </button>
    );
  }
);

Button.displayName = 'Button';

export default Button;
